import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7069bebf&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7069bebf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7069bebf')) {
      api.createRecord('7069bebf', component.options)
    } else {
      api.reload('7069bebf', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7069bebf&scoped=true&", function () {
      api.rerender('7069bebf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Loading/index.vue"
export default component.exports